(function () {

  function getRoot(el) {
    return el && el.closest('[data-pa-product-root]');
  }

  function getPanels(root) {
    return Array.from(
      root.querySelectorAll('[data-pa-media-panel]')
    );
  }

  function activateMedia(root, id) {

    root.querySelectorAll('[data-pa-media-thumb]').forEach(function (thumb) {
      thumb.classList.toggle(
        'is-active',
        thumb.getAttribute('data-pa-media-thumb') === id
      );
    });

    root.querySelectorAll('[data-pa-media-panel]').forEach(function (panel) {

      panel.style.removeProperty('display');
      panel.style.removeProperty('visibility');
      panel.style.removeProperty('opacity');
      panel.style.removeProperty('transform');
      panel.style.removeProperty('transition');
      panel.style.removeProperty('z-index');
      panel.style.removeProperty('pointer-events');
      panel.style.removeProperty('will-change');

      var active =
        panel.getAttribute('data-pa-media-panel') === id;

      panel.classList.toggle('is-active', active);

      if (!active) {
        panel.querySelectorAll('video').forEach(function (video) {
          try {
            video.pause();
          } catch (e) {}
        });
      }

    });

  }


  function moveMedia(root, direction) {

    var panels = getPanels(root);

    if (panels.length < 2) return;

    var currentIndex = panels.findIndex(function (panel) {
      return panel.classList.contains('is-active');
    });

    if (currentIndex < 0) {
      currentIndex = 0;
    }

    var nextIndex =
      (currentIndex + direction + panels.length) %
      panels.length;

    var nextId =
      panels[nextIndex].getAttribute('data-pa-media-panel');

    activateMedia(root, nextId);
  }


  document.addEventListener(
    'click',
    function (event) {

      var thumb =
        event.target.closest('[data-pa-media-thumb]');

      if (thumb) {

        var root = getRoot(thumb);

        if (!root) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        activateMedia(
          root,
          thumb.getAttribute('data-pa-media-thumb')
        );

        return;
      }


      var prev =
        event.target.closest('[data-pa-media-prev]');

      if (prev) {

        var rootPrev = getRoot(prev);

        if (!rootPrev) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        moveMedia(rootPrev, -1);

        return;
      }


      var next =
        event.target.closest('[data-pa-media-next]');

      if (next) {

        var rootNext = getRoot(next);

        if (!rootNext) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        moveMedia(rootNext, 1);

        return;
      }

    },
    true
  );

})();